// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"abaf4b7f","721":"6ac358fb"}[chunkId] + ".chunk.css";
};